export function bidiNumber($rootScope) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs, ctrl) {

            if ($rootScope.$lang === 'ar') {

                element.css('direction', 'ltr')
                    .css('text-align', 'right');
            }
        }
    };
}

bidiNumber.$inject = [
    '$rootScope',
];



// WEBPACK FOOTER //
// ./src/ui/directives/bidi-number.directive.js